import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { ArrowRight, Calendar, User } from "lucide-react";
import { useNavigate } from "react-router";
import { path } from "../../../utils/common/constant";

interface NewsCardProps {
  t: any;
  news: INews;
}

const NewsCard: React.FC<NewsCardProps> = ({ t, news }) => {
  const navigate = useNavigate();

  function formatDateString(dateString: string) {
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
  }

  return (
    <div className="border flex flex-col rounded-2xl w-full justify-center items-start bg-white text-[#074799] cursor-pointer hover:shadow-xl hover:-translate-y-3 duration-300">
      <div className="w-full xl:h-[333px] lg:h-[250px] h-full relative overflow-hidden rounded-t-2xl custom-lazy-load">
        <LazyLoadImage
          src={news.thumbnail}
          alt={news.title}
          effect="blur"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="w-full flex flex-col px-10 py-6 gap-4 flex-1">
        <div className="flex justify-between max-xl:flex-col max-xl:items-start max-xl:gap-2">
          <div className="text-black flex gap-2 justify-center items-center xl:text-base text-sm">
            <Calendar size={16} />
            <p>{formatDateString(news.create_date)}</p>
          </div>

          <div className="text-black flex gap-2 justify-center items-center xl:text-base text-sm">
            <User size={16} />
            <p>{news.author.name}</p>
          </div>
        </div>

        <div className="w-full flex flex-col gap-4">
          <p
            className="xl:text-[22px] text-xl leading-8 font-bold line-clamp-3"
            style={{
              height: "calc(2rem * 3)"
            }}
          >
            {news.title}
          </p>

          <p
            className="text-black line-clamp-2 text-base"
            style={{
              height: "calc(1rem * 3)"
            }}
          >
            {news.subtitle}
          </p>

          <div
            className="flex gap-2 font-semibold justify-start items-center xl:text-base text-sm hover:underline"
            onClick={() =>
              navigate("../" + path.NEWS_DETAIL, { state: { news } })
            }
          >
            {t("cta.read_more")}
            <ArrowRight size={16} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;
